import PropTypes from 'react-proptypes';
import styled from '@emotion/styled';
import { NextStepButton, PreviousStepButton } from '../buttons';

const NavigationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 40px 0 0;
`;

const NavigationButtons = ({
  showNextButton,
  onClickNext,
  nextLabel,
  showPreviousButton,
  onClickPrevious,
  previousLabel,
  loading,
}) => (
  <NavigationContainer>
    {showPreviousButton ? (
      <PreviousStepButton handleClick={onClickPrevious} loading={loading} >
        {previousLabel}
      </PreviousStepButton>
    ) : <div />}
    {showNextButton ? (
      <NextStepButton handleClick={onClickNext} loading={loading}>
        {nextLabel}
      </NextStepButton>
    ) : <div />}
  </NavigationContainer>
);

NavigationButtons.propTypes = {
  showNextButton: PropTypes.bool.isRequired,
  onClickNext: PropTypes.func,
  nextLabel: PropTypes.string,
  showPreviousButton: PropTypes.bool.isRequired,
  onClickPrevious: PropTypes.func,
  previousLabel: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

NavigationButtons.defaultProps = {
  nextLabel: '',
  previousLabel: '',
  onClickNext() {},
  onClickPrevious() {},
}

export default NavigationButtons;
